import api from '../../utils/services/api';
import { showAlert } from '../ducks/sweetAlert';
import { transactionsActionError, transactionsActionLoading, transactionsActionSuccess } from '../ducks/transactions';
import { userBalanceFetchAction } from './usersActions';
import { transfersFetchAction } from './transfersActions';

export const transactionsFetchAction = (params) => {
  return async (dispatch) => {
    dispatch(transactionsActionLoading());
    try {
      const response = await api.get(
        `/transacoes-dashboard/grafico?DATA_INICIAL=${params.dataMenoSete}&DATA_FINAL=${params.dataHoje}`,
      );
      dispatch(transactionsActionSuccess(response.data));
    } catch (error) {
      dispatch(transactionsActionError(error?.response?.data));
    }
  };
};

export const transactionsRefetchFailedAction = (params) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`/antifraude/analise`, params)
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: response.data?.data?.mensagem || 'Análise reprocessada com sucesso',
          icon: 'success',
        }),
      );
      dispatch(transfersFetchAction({ ORDENACAO: "DESC", ...params  }));
    } catch (error) {
      dispatch(transactionsActionError());
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possível reprocessar a análise.',
          icon: 'error',
        }),
      );
    }
  };
};

export const performMakeTransactionAdmin = (params, closeModal) => {
  return async (dispatch) => {
    const closeModals = () => {
      closeModal();
      dispatch(
        userBalanceFetchAction({
          ID_CONTA: params?.ID_CONTA,
          CPFCNPJ_CLIENTE: params?.CPFCNPJ_CLIENTE,
          LIMIT: 10,
          PAGE: 1,
        }),
      );
    };
    dispatch(transactionsActionLoading());
    try {
      const response = await api.post(`/transacao/transferencia-manutencao/adm`, params);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: response.data?.data?.mensagem || 'Transferência realizada com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
      dispatch(transactionsFetchAction({ LIMIT: 10, ORDENACAO: 'DESC', PAGE: 1 }));
    } catch (error) {
      dispatch(transactionsActionError());
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possível realizar a transferência.',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};
